import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_heat-dispatch/artifacts/5ljah6z6_image.png";

export default function Footer() {
  return (
    <footer className="relative bg-brand-navy text-white border-t-4 border-brand-red" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-4">
            <img src={LOGO_URL} alt="McFly's Fuel Inc." className="h-32 w-auto block" style={{ mixBlendMode: "screen" }} />
            <div>
              <div className="font-heading text-2xl">McFly's Fuel Inc.</div>
              <div className="text-xs uppercase tracking-[0.25em] text-brand-gold">Reliable • Affordable • Fast</div>
            </div>
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            Long Island's dependable heating oil delivery service. Family-owned, licensed and insured, residential delivery only — keeping your home warm all season.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-bold mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone size={14} className="text-brand-red" /> <a href="tel:6313723526" className="hover:text-brand-gold">631-372-3526</a></li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-brand-red" /> <a href="mailto:mcflysfuel@gmail.com" className="hover:text-brand-gold">mcflysfuel@gmail.com</a></li>
            <li className="flex items-center gap-2"><MapPin size={14} className="text-brand-red" /> Suffolk County, NY</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-bold mb-4">Hours</div>
          <div className="text-sm text-white/60 italic">Coming soon</div>
          <div className="text-brand-gold font-semibold pt-3 text-sm">24/7 Emergency Service</div>
        </div>
      </div>
      <div className="border-t border-white/10 bg-brand-red">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between text-xs text-white font-heading tracking-[0.2em]">
          <div>© {new Date().getFullYear()} McFLY'S FUEL INC. · LONG ISLAND, NY</div>
          <div className="flex gap-5 mt-3 sm:mt-0">
            <a href="/admin/login" className="hover:text-brand-gold" data-testid="footer-admin-link">ADMIN</a>
            <span className="text-brand-gold">LICENSED · INSURED</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
